app.factory("StaticData", ['$http', '$q',
    function ($http, $q) {
        var StaticData = {
            data: null,
            systemParams: null
        };

        StaticData.loadStatics = function () {
            return $http.get("/config/list").then(function (resp) {
                StaticData.data = resp.data;
                return StaticData.data;
            });
        };

        StaticData.loadSystemParams = function () {
            return $http.get("/sysparam/list").then(function (resp) {
                StaticData.systemParams = resp.data;
                return StaticData.systemParams;
            });
        };

        StaticData.isLoaded = function () {
            return StaticData.data !== null;
        };

        StaticData.filterKeys = function (key) {
            var filtered = StaticData.data.filter(function (el) {
                return el._id === key;
            });

            if (filtered.length !== 1) {
                return null;
            }

            return filtered[0];
        };

        StaticData.getByKey = function (key) {
            if (StaticData.isLoaded()) {
                return $q.resolve(StaticData.filterKeys(key))
            } else {
                return StaticData.loadStatics().then(function () {
                    return StaticData.filterKeys(key);
                });
            }
        };

        StaticData.getItemsByKey = function (key) {
            return StaticData.getByKey(key).then(function (item) {
                // console.log(item);
                return item.data.items;
            });
        };

        StaticData.getParamByKey = function (key) {
            var param = _.find(StaticData.systemParams, {_id: key});
            if (!param) return null;
            var value = param.value;
            if (param.type === 'Date') value = new Date(value);
            else if (param.type === 'Number') value = Number(value);
            else value = value.toString();
            return value;
        };

        StaticData.getSystemParam = function (key) {
            if (StaticData.systemParams) {
                return $q.resolve(StaticData.getParamByKey(key));
            } else {
                return StaticData.loadSystemParams().then(function () {
                    return StaticData.getParamByKey(key);
                })
            }
        };

        StaticData.loadStatics();
        StaticData.loadSystemParams();

        return StaticData;
    }
]);
